(() => {
  const init = () => {
    if (!document.querySelector('.support-hub--landing')) return;
    const header = document.querySelector('.sg-header-shell');
    if (!header || header.dataset.supportScrollBound) return;
    header.dataset.supportScrollBound = 'true';
    let queued = false;
    const sync = () => {
      header.classList.toggle('sh-header-scrolled', window.scrollY > 80);
      queued = false;
    };
    window.addEventListener('scroll', () => {
      if (!queued) { queued = true; requestAnimationFrame(sync); }
    }, { passive: true });
    window.addEventListener('pageshow', sync);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
